import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=5f2c80c0&scoped=true"
import script from "./candidates.ts?vue&type=script&lang=ts&external"
export * from "./candidates.ts?vue&type=script&lang=ts&external"
import style0 from "./Candidates.vue?vue&type=style&index=0&id=5f2c80c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c80c0",
  null
  
)

export default component.exports